<template>
  <div class="guide-box">
    <a class="guide-box-content" :href="cardInfo.link" target="_blank">
      <i class="iconfont iconwhitepaper-icon1"></i>
      <h2 class="title">{{ cardInfo.title }}</h2>
      <span class="more">
        <span>查看全文</span>
        <i class="iconfont iconjiantou-copy"></i>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  props: ['cardInfo']
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.guide-box {
  padding: 31px;
  margin-bottom: 32px;
  width: 31.7%;
  height: 212px;
  border-radius: 2px;
  box-sizing: border-box;
  border: 1px solid $border-color1;
  // transition: box-shadow 0.3s ease;
  transition: box-shadow .3s ease-in-out, transform .3s ease-in-out;
  cursor: pointer;

  @include mobile {
    margin-bottom: 18px;
  }

  &:hover {
    // box-shadow: 0 2px 8px 3px $shadow-color;
    box-shadow: 0 2px 4px 0 rgba(60, 64, 67, .3), 0 6px 11px 5px rgba(60, 64, 67, .15);
    transform: translateY(-4px);
  }
  .guide-box-content {
    position: relative;
    // display: flex;
    // flex-direction: column;
    // justify-content: space-between;
    // align-items: center;
    width: 100%;
    height: 100%;
    .iconwhitepaper-icon1 {
      display: block;
      margin-bottom: 12px;
      color: $primary1;
      font-size: 34px;
      line-height: 1;
      // background-color: $primary1;
      border-radius: 2px;
    }
    .title {
      line-height: 27px;
      color: $font-color1;
      font-size: $fontSize20;
      font-weight: 500;
    }
    .more {
      position: absolute;
      bottom: 0; right: 0;
      line-height: 1;
      color: $primary2;
      font-size: $fontSize14;
      font-weight: 500;
      display: flex; align-items: center;
      span {
        line-height: 1;
      }
      .iconjiantou {
        color: $primary3;
        font-size: 12px;
        margin-left: 4px;
      }
    }
  }
}

@include mobile {
  .guide-box {
    width: 100%;
  }
}
</style>
